export default __webpack_public_path__ + "static/YourFirstDays-ca1538d43d996b7d59eede1bac8d15c7.png";